module.exports = __webpack_public_path__ + "static/media/Projects.af478b01.svg";